import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FeeWaiverAuditLogDrawerService {
    readonly auditLogDrawerFeeWaiverId = signal<number | null>(null);

    openFeeWaiverAuditLogDrawer(feeWaiverId: number | null): void {
        this.auditLogDrawerFeeWaiverId.set(feeWaiverId);
    }
}
